// extracted by mini-css-extract-plugin
export default {"portal":"Portal_portal__mPSeP","content":"Portal_content__rsfJz","admin_login":"Portal_admin_login__5F6D+"};